import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";
import styled, { css } from "styled-components";


const exampleTabs = {
  active: "configure",
  handleTab: nw => {
    void(0)
  },
  items: [
    {
      name: "Configure",
      stateName: "configure",
      icon: "settings"
    },
    {
      name: "Preview",
      stateName: "preview",
      icon: "show"
    }
  ],
  extra:<div/>
  }







export default function PAtabs ({
  active,
  handleTab = () => {void(0)},
  items = [],
  appearance='primary',
  extra,
}) {
  // console.log('action123 = ', action);

  const [state, setState] = useState(active)

  useEffect(() => {
    if (state !== active) {
      setState(active);
      // handleTab(active)
    }
  }, [active])

  return (

      <div
        className={appearance !== 'secondary' ? `ui-navigation ui-navigation--size-xs ui-navigation--bordered` : `ui-navigation ui-navigation--size-xs`}
        style={{minHeight: 'auto',
        width: '100%',
      }}
      >
        <CSSmenu0 className="ui-navigation__menu">
          <CSSmenu1 className="ui-navigation__section" style={{
              width: '100%',
              minHeight: 46,
            }}>


            {items.map((oneItem, ind)=>{
              return (
                <CSStabsLi
                  key={`oneTab_${ind}`}
                  style={{
                    cursor: "pointer",
                    borderBottomColor:
                    (appearance !== 'secondary' && state === oneItem['stateName'])
                    ? '#0073f7' : 'transparent',
                    borderLeft:
                    (appearance === 'secondary' && ind)
                    ? '1px solid #c5d0db' : 'transparent',
                    height: (appearance === 'secondary') ? '24px' : 'auto',
                    paddingTop: (appearance === 'secondary') ? 0 : 'auto',
                    paddingBottom: (appearance === 'secondary') ? 0 : 'auto',
                    paddingLeft:
                    (appearance === 'secondary')
                    ? 16 : 'auto',
                    marginRight:
                    (appearance === 'secondary')
                    ? 16 : 36,
                }}
                onClick={() => {
                  setState(oneItem['stateName']);
                  handleTab(oneItem['stateName'])
                }}
                className={`ui-navigation__item ${
                  state === oneItem['stateName']
                    ? "ui-navigation__item--active"
                    : ""
                }`}
              >
                <span style={{marginRight: 4, marginTop: 8}}>{(typeof oneItem.icon !== 'undefined') &&
                  <Icon name={oneItem.icon} size={20}/>
                }</span>
                {oneItem['name']}
                </CSStabsLi>
              )
            })}

            {/* {(typeof extra !== 'undefined' ) &&  */}
            <div style={{flexGrow: 1, justifyContent: 'flex-end', display: 'flex'}}>
              {extra}
            </div>
            {/* } */}

          </CSSmenu1>
          <div className="ui-navigation__section ui-navigation__section--actions" />
        </CSSmenu0>
      </div>

  )
}

const CSSmenu0 = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: 767px) {
    display: block;
  }
`;

const CSStabsLi = styled.div`
  cursor: pointer;

  ${({appearance, active}) => appearance && appearance === 'secondary' && active && css`
    border-bottom-color: #0073f7;
  `}
  ${({appearance, active}) => appearance && appearance === 'secondary' && css`
    border-left: 1px solid #c5d0db;
    height: 24px;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 16px;
    margin-right: 16px;
  `}

  /* border-bottom-color: (appearance !== 'secondary' && state === oneItem['stateName']) ? '#0073f7' : 'transparent; */
  /* border-left: (appearance === 'secondary' && ind) ? '1px solid #c5d0db' : 'transparent; */
  /* height: (appearance === 'secondary') ? '24px' : 'auto; */
  /* padding-top: (appearance === 'secondary') ? 0 : 'auto; */
  /* padding-bottom: (appearance === 'secondary') ? 0 : 'auto; */
  /* padding-left: (appearance === 'secondary') ? 16 : 'auto; */
  /* margin-right: (appearance === 'secondary') ? 16 : 36; */
  @media (max-width: 767px) {

  }
`;

const CSSmenu1 = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`;
